import { api } from "./api"

let storeInstance = null;

async function loadStore() {
  if (!storeInstance) {
    storeInstance = (await import('../services/store.js')).store
  }
  return storeInstance
}

const mode = import.meta.env.MODE;

export const environmentService = {
    async get() {
        try {
            console.log('[Environment Service] Fetching environment from:', mode === 'development' ? 'http://localhost:8081/environment' : '/environment');
            const res = await api.get('/environment', {
                baseURL: mode === 'development' ? 'http://localhost:8081' : '',
                timeout: 10000, // 10 second timeout
                skipLoading: true,
            });
            console.log('[Environment Service] Received environment:', res.data);
            
            // Save to Redux store for other components to use
            const store = await loadStore();
            store.dispatch({ type: 'setEnvironment', payload: res.data });
            console.log('[Environment Service] Saved to Redux store');
            
            return res.data;
        } catch (error) {
            console.error('[Environment Service] Failed to fetch environment:', error.message);
            // Return a fallback to prevent infinite loading
            return {
                sliceId: '',
                customerId: null,
                impersonating: false
            };
        }
    }
}